import CustomStyleSheet from '@prahatech/util-react-web/stylesheet/CustomStyleSheet';

export function ThankYouScreen() {
  document.title = 'docpay - Thank you!';

  return (
    <div className='thank-you-screen'>
      <h1>Thank you.</h1>

      <p>All actions have been completed.</p>
    </div>
  );
}

const scope = '.thank-you-screen';
const styles = `
  {
    flexbox: column center center;
    width: 100%;
    height: 100%;
    padding: 15px;
  }

  h1 {
    color: conf(color, primary);
    margin: 0;
    font-preset: 3em light;
    text-align: center;
    padding-bottom: conf(spacing, smallest);
  }

  p {
    color: conf(color, darkerGrey);
    font-preset: 1.2em light;
    text-align: center;
    margin: 0;
  }
`;

CustomStyleSheet.create(styles, scope);
